import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, TextButton, useOpenModal } from '@modusign/design-system';
import { useQueryClient } from 'react-query';

import useResponsiveValue from '@app/hooks/useResponsiveValue';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

import LabelCreationModal from '../../../LabelCreationModal';

function LabelSelectPopoverFooter({ onClear }: { onClear?: () => void }) {
  const openModal = useOpenModal();
  const workspaceId = useWorkspaceId();

  const isMobileWidth = useResponsiveValue([true, false, false]);

  const queryClient = useQueryClient();

  return (
    <Flex alignItems="center" as="section" justifyContent="space-between" p={4} width="100%">
      {onClear && <TextButton onClick={onClear}>선택 안 함</TextButton>}
      {!isMobileWidth && (
        <TextButton
          fontSize="md"
          fontWeight="medium"
          onClick={() => {
            openModal(({ onClose }) => (
              <LabelCreationModal
                onCancel={onClose}
                onCreated={() => {
                  queryClient.invalidateQueries(
                    // TODO: getGetLabelListQueryKey(workspaceId) /** getGetLabelListQueryKey의 2번째 인자기 필수여서 사용하기 부적절함으로 아래 라인 문자열로 대체 */
                    [`/workspaces/${workspaceId}/labels`]
                  );
                  onClose();
                }}
              />
            ));
          }}
        >
          <Box as={FontAwesomeIcon} fontSize="12px" icon={faPlus} />새 라벨
        </TextButton>
      )}
    </Flex>
  );
}

export default LabelSelectPopoverFooter;
